import CommentIcon from "@mui/icons-material/ThreePOutlined";
import { Paper, Stack, Typography } from "@mui/material";

interface Props {
  comment: string;
}

const ChangeRequestComment = ({ comment }: Props) => {
  return (
    <Paper variant="outlined" sx={{ p: 1.5 }}>
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <CommentIcon color="action" />
          <Typography color="textSecondary">User comment</Typography>
        </Stack>

        <Typography sx={{ whiteSpace: "break-spaces" }}>{comment}</Typography>
      </Stack>
    </Paper>
  );
};

export default ChangeRequestComment;
